import dayjs from "dayjs";

export const timeUTCFormat = (originalDate: string | Date) => {
  const date = new Date(originalDate);
  const hh = date.getUTCHours();
  const mm = date.getUTCMinutes();

  const formattedHours = hh < 10 ? `0${hh}` : hh;
  const formattedMinutes = mm < 10 ? `0${mm}` : mm;

  return originalDate ? `${formattedHours}:${formattedMinutes}` : "";
};

export const dateFormatBookingDate = (
  bookingDate?: Date | string,
  time?: string
): string | undefined => {
  return bookingDate
    ? dayjs(`${dayjs(bookingDate).format("MM/DD/YYYY")} ${time}`)
        .utc(true)
        .toISOString()
    : undefined;
};

export const timeFormatResponse = (booking_time: string) => {
  const hour = booking_time.slice(0, 2);
  const minutes = booking_time.slice(2);
  return `${hour.padStart(2, "0")}:${minutes.padStart(2, "0")}`;
};
